import React from "react";
import {DropzoneState} from "react-dropzone";

import T from "@translate/T";

interface IDropAreaProps {
    args: DropzoneState;
    cta: JSX.Element;
}

class DropArea extends React.PureComponent<IDropAreaProps> {
    public render() {
        const {args, cta} = this.props;

        return (
            <div
                id="drop-area-div"
                className="border pointer-cursor"
                {...args.getRootProps()}
                // onClick={this.onClick} // if click does not work: click on div -> this.ref.current.click()
            >
                <input id="drop-area-input" {...args.getInputProps()} />
                <div className="text-center mx-3 my-5">
                    {cta}
                    <br />
                    <T>Or drag and drop file(s) here.</T>
                </div>
            </div>
        );
    }
}

export default DropArea;
